import React from "react";

export function Textbox({ label, name, defaultValue, placeholder = "", isReadonly = false, value, onValueChange }: { label: string, name: string, placeholder?: string, defaultValue?: string, isReadonly?: boolean, value?: string, onValueChange?: (e: React.ChangeEvent<HTMLInputElement>) => void }) {
    return (
        <div className="grid grid-cols-1 grow mb-4">
            <label className="basic-form-label">
                <span>  {label}</span>
            </label>
            <input type="text" className="basic-form-box" name={name} placeholder={placeholder} onChange={onValueChange} defaultValue={defaultValue} value={value} readOnly={isReadonly} />
        </div>
    );
}